import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetEmspUsersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.form-default-values';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchEmspBoEmspUserListContextProvider,
  useEmspBoEmspUserListContext,
} from '../emsp-bo-emsp-user.context';
import { EmspBoEmspUserListFilterSearchFormController } from './emsp-bo-emsp-user-list-filter-search-form/emsp-bo-emsp-user-list-filter-search-form.controller';

interface EmspBoEmspUserListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoEmspUserListFilterSearchController = ({
  onCancel,
  onSuccess,
}: EmspBoEmspUserListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoEmspUserListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetEmspUsersPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-user-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetEmspUsersPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      textToSearch: fieldValues.textToSearch,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetEmspUsersPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchEmspBoEmspUserListContextProvider data={data}>
      <EmspBoEmspUserListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchEmspBoEmspUserListContextProvider>
  );
};
